import React, { useEffect,  useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import FASParentChild from "../../../../../components/Tables/FASParentChild";
import { MainFilter } from "../../../../../Redux/Slice/login/loginSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "lucide-react";
import {
  OpBalNetFan,
  TrialOpBalNet,
} from "../../../../../Redux/Slice/Fas/Financial Statement/Trial Balance/TrialBalanceSlice";
import { useTheme } from "../../../../../Themecontext/Themecontext";
import FASparentMultipalChild from "../../../../../components/Tables/FASparentMultipalChild";
export default function Detail({ accountGroup, ToDate, Fromdate }) {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { TrialOpBalNetdata } = useSelector((state) => state.TrialBalanceSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");
  const { theme } = useTheme();
  const isdark = theme;

  useEffect(() => {
    dispatch(OpBalNetFan());
    dispatch(
      TrialOpBalNet({
        Firm,
        Year: FinancialYear,
        selectedIds: accountGroup.join(","),
        Fromdate,
        ToDate,
      }),
    );
  }, [dispatch, Firm, FinancialYear, accountGroup, Fromdate, ToDate]);

  const formatAmount = (value) => {
    if (!value || value === "(Multiple)") return 0;
    const num = Number(value.toString().replace(/,/g, ""));
    return isNaN(num) ? 0 : num;
  };

  const getRows =
    TrialOpBalNetdata?.Detail?.map((item, index) => {
      return {
        srNumber: index + 1,
        AcLaieName: item.AcLaieName,
        GroupMstName: item.GroupMstName,
        AcName: item.AcName || "",
        OpCrAmt: item.OpCrAmt,
        OpDrAmt: item.OpDrAmt,
        TriCrAmt: item.TriCrAmt,
        TriDrAmt: item.TriDrAmt,
        NetBalCrAmt: item.NetBalCrAmt,
        NetBalDrAmt: item.NetBalDrAmt,
      };
    }) || [];

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Ac Type",
      key: "AcLaieName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
      width: "180px",
    },
    { label: "Count", key: "count", align: "center" },
    {
      label: "AcGroup Name",
      key: "GroupMstName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Account Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Opening DrAmt", key: "OpDrAmt", format: true, align: "right" },
    { label: "Opening CrAmt", key: "OpCrAmt", format: true, align: "right" },
    {
      label: "Transaction DrAmt",
      key: "TriDrAmt",
      format: true,
      align: "right",
    },
    {
      label: "Transaction CrAmt",
      key: "TriCrAmt",
      format: true,
      align: "right",
    },
    {
      label: "NetBalance DrAmt",
      key: "NetBalDrAmt",
      format: true,
      align: "right",
    },
    {
      label: "NetBalance CrAmt",
      key: "NetBalCrAmt",
      format: true,
      align: "right",
    },
  ];

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });
    const formatIndianAmount = (value) => {
      const num = Number(value || 0);

      return num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;

    /* ================= TITLE ================= */
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");

    const title = "Trial Balance Detail";

    doc.text(title, pageWidth / 2, 15, {
      align: "center",
    });

    doc.setLineWidth(0.5);
    doc.line(marginX, 18, pageWidth - marginX, 18);

    /* ================= FIRM NAME ================= */
    const firmName = DataMain?.Firm_List?.[0]?.GroupName || "";

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");

    doc.text(firmName, pageWidth / 2, 25, {
      align: "center",
    });

    /* ================= TABLE START POSITION ================= */
    let startY = 33;
    /* ================= DATA ================= */

    const allRows = TrialOpBalNetdata?.Detail || [];

    const summary = TrialOpBalNetdata?.Summary?.[0] || {};
    const groupOrder = {
      Liabilities: 1,
      Assets: 2,
      Income: 3,
      Expense: 4,
    };

    const orderedRows = [...(TrialOpBalNetdata?.Detail || [])].sort((a, b) => {
      const orderA = groupOrder[a.AcLaieName] || 999;
      const orderB = groupOrder[b.AcLaieName] || 999;

      if (orderA !== orderB) {
        return orderA - orderB;
      }

      return (a.GroupMstName || "").localeCompare(b.GroupMstName || "");
    });

    /* ================= BODY ================= */
    let sr = 1;

    const bodyRows = orderedRows.map((row) => [
      sr++,
      row.AcLaieName || "",
      row.GroupMstName || "",
      row.AcName || "",
      formatIndianAmount(row.OpDrAmt),
      formatIndianAmount(row.OpCrAmt),
      formatIndianAmount(row.TriDrAmt),
      formatIndianAmount(row.TriCrAmt),
      formatIndianAmount(row.NetBalDrAmt),
      formatIndianAmount(row.NetBalCrAmt),
    ]);
    bodyRows.push([
      "",
      "",
      "",
      "TOTAL",
      formatIndianAmount(summary?.OpDrAmt || 0),
      formatIndianAmount(summary?.OpCrAmt || 0),
      formatIndianAmount(summary?.TriDrAmt || 0),
      formatIndianAmount(summary?.TriCrAmt || 0),
      formatIndianAmount(summary?.NetBalDrAmt || 0),
      formatIndianAmount(summary?.NetBalCrAmt || 0),
    ]);
    /* ================= COLUMN WIDTH ================= */
    const colWidths = [10, 28, 35, 45, 25, 25, 25, 25, 25, 25];
    const tableWidth = colWidths.reduce((a, b) => a + b, 0);
    const leftMargin = (pageWidth - tableWidth) / 2;

    /* ================= TABLE ================= */
    autoTable(doc, {
      startY,

      head: [
        [
          "Sr",
          "Ac Type",
          "Ac Group",
          "Account Name",
          "Op Dr",
          "Op Cr",
          "Tr Dr",
          "Tr Cr",
          "Net Dr",
          "Net Cr",
        ],
      ],
      body: bodyRows,

      theme: "grid",

      styles: {
        fontSize: 8,
        cellPadding: 2,
        valign: "middle",
        textColor: [0, 0, 0],
        lineColor: [210, 210, 210],
        lineWidth: 0.2,
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        fontSize: 9,
      },

      bodyStyles: {
        fontStyle: "bold",
      },

      columnStyles: {
        0: { cellWidth: 16, halign: "left" },
        1: { cellWidth: 22 },
        2: { cellWidth: 33 },
        3: { cellWidth: 40 },
        4: { cellWidth: 28, halign: "right" },
        5: { cellWidth: 28, halign: "right" },
        6: { cellWidth: 28, halign: "right" },
        7: { cellWidth: 28, halign: "right" },
        8: { cellWidth: 28, halign: "right" },
        9: { cellWidth: 28, halign: "right" },
      },

      didParseCell(data) {
        if (data.row.raw?.[3] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [240, 240, 240];
        }
      },
    });

    doc.save("Trial_Balance_Detail.pdf");
  };

  if (TrialOpBalNetdata === "no" || TrialOpBalNetdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <button
          onClick={handleDownload}
          className="common-hover-btn"
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6,
            color:
              isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour12,
            border: "none",
            padding: "10px 16px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
            fontWeight: "500",
            fontSize: "14px",
            height: "44px",
          }}
        >
          <Download size={16} />
          Download PDF
        </button>
      </div>
      <div style={{ marginTop: "20px" }}>
        <div
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
          }}
        >
          {/* HEADER */}
          <div
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              padding: "14px",
              margin: 0,
              position: "relative",
              zIndex: 2,
            }}
          >
            <h2
              style={{
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
                fontWeight: "600",
              }}
            >
              DETAIL
            </h2>
          </div>

          {/* TABLE */}
          {/* <FASparentMultipalChild
            columns={getColumns}
            data={getRows}
            externalTotals={TrialOpBalNetdata?.Summary?.[0] || {}}
          /> */}

          <FASparentMultipalChild
            columns={getColumns}
            data={getRows}
            externalTotals={TrialOpBalNetdata?.Summary?.[0] || {}}
          />
        </div>
      </div>
    </>
  );
}
